import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFocusAuto: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="focus-auto"><path d="M3.75 8V3.75H8M3.75 16V20.25H8M16 3.75H20.25V8M20.25 16V20.25H16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path fillRule="evenodd" clipRule="evenodd" d="M11.0259 8L8 16H9.70708L10.1768 14.7582H13.8232L14.2929 16H16L12.9741 8H11.0259ZM13.1249 12.9121L12 9.93791L10.8751 12.9121H13.1249Z" fill="currentColor"/></CentralIconBase>;
};

export default IconFocusAuto;
